import React from "react";
import { Input, ActionButton, PictureUpload, SignatureField } from "../../shared";
import { Icons } from "../../shared/Icons";
import { handleCnpjInputChange } from "../../../utils/cnpjUtils";

interface CompanyInfoProps {
  companyData: {
    name: string;
    email: string;
    phoneNumber: string;
    address: string;
    cnpj: string;
    instagramUrl: string;
    logo?: string;
    signature?: string;
  };
  setCompanyData: React.Dispatch<
    React.SetStateAction<{
      name: string;
      email: string;
      phoneNumber: string;
      address: string;
      cnpj: string;
      instagramUrl: string;
      logo?: string;
      signature?: string;
    }>
  >;
  onSave: () => void;
  saving: boolean;
  currentLogo?: string;
  currentSignature?: string;
}

export const CompanyInfo: React.FC<CompanyInfoProps> = ({
  companyData,
  setCompanyData,
  onSave,
  saving,
  currentLogo,
  currentSignature,
}) => {

  return (
    <div className="bg-white dark:bg-slate-800 rounded-2xl shadow-medium border border-gray-100 dark:border-slate-700 overflow-hidden">
      <div className="px-6 py-4 border-b border-gray-200 dark:border-slate-700">
        <h3 className="text-xl font-bold text-gray-900 dark:text-white flex items-center gap-3">
          <span className="text-2xl">🏢</span>
          Informações do Negócio
        </h3>
      </div>
      <div className="p-6 space-y-4">
        {/* Logo Upload */}
        <PictureUpload
          label="Logo da Empresa"
          value={companyData.logo}
          currentImage={currentLogo}
          onChange={(base64) =>
            setCompanyData({ ...companyData, logo: base64 })
          }
          onRemove={() => setCompanyData({ ...companyData, logo: "" })}
          disabled={saving}
        />

        <SignatureField
          label="Assinatura da Empresa"
          value={companyData.signature}
          currentImage={currentSignature}
          onChange={(base64) =>
            setCompanyData({ ...companyData, signature: base64 })
          }
          onRemove={() => setCompanyData({ ...companyData, signature: "" })}
          disabled={saving}
          hint="Exibida no rodapé dos orçamentos em PDF"
        />

        <Input
          id="companyName"
          label="Nome da Empresa"
          type="text"
          value={companyData.name}
          onChange={(e) =>
            setCompanyData({ ...companyData, name: e.target.value })
          }
          placeholder="Nome do Salão de Beleza"
        />
        <Input
          id="companyPhone"
          label="Telefone de Contato"
          type="tel"
          value={companyData.phoneNumber}
          onChange={(e) =>
            setCompanyData({
              ...companyData,
              phoneNumber: e.target.value,
            })
          }
          placeholder="+55 11 99999-9999"
        />
        <Input
          id="companyEmail"
          label="Endereço de Email"
          type="email"
          value={companyData.email}
          onChange={(e) =>
            setCompanyData({ ...companyData, email: e.target.value })
          }
          placeholder="contato@salao.com"
        />
        <Input
          id="companyAddress"
          label="Endereço"
          type="text"
          value={companyData.address}
          onChange={(e) =>
            setCompanyData({ ...companyData, address: e.target.value })
          }
          placeholder="Rua, Cidade, Estado"
        />
        <Input
          id="companyCnpj"
          label="CNPJ"
          type="text"
          value={companyData.cnpj}
          onChange={(e) =>
            handleCnpjInputChange(e.target.value, (formatted) =>
              setCompanyData({ ...companyData, cnpj: formatted })
            )
          }
          placeholder="00.000.000/0000-00"
        />
        <Input
          id="companyInstagram"
          label="Instagram"
          type="url"
          value={companyData.instagramUrl}
          onChange={(e) =>
            setCompanyData({ ...companyData, instagramUrl: e.target.value })
          }
          placeholder="https://instagram.com/suaempresa ou @usuario"
        />
        <div className="pt-4 border-t border-gray-200 dark:border-slate-700">
          <ActionButton
            onClick={onSave}
            disabled={saving}
            loading={saving}
            variant="primary"
            size="sm"
            className="w-full justify-center"
            icon={saving ? <Icons.Refresh sx={{ fontSize: 18 }} className="animate-spin" /> : <Icons.Save sx={{ fontSize: 18 }} />}
          >
            {saving ? "Salvando..." : "Salvar"}
          </ActionButton>
        </div>
      </div>
    </div>
  );
};
